"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGlobalPortal = exports.GLOBAL_PORTAL_ID = void 0;
const react_1 = require("react");
const react_dom_1 = require("react-dom");
exports.GLOBAL_PORTAL_ID = 'globals-portal';
function useGlobalPortal() {
    const elementRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        elementRef.current = document.querySelector('#globals-portal');
    }, []);
    return (el) => elementRef.current ? (0, react_dom_1.createPortal)(el, elementRef.current) : null;
}
exports.useGlobalPortal = useGlobalPortal;
